// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-t-20[data-v-348e3a20] {\n  margin-bottom: 1.25rem; /* 20px */\n}\n", ""]);
// Exports
module.exports = exports;
